import { graphql } from '../../generated';

export const BLOCK_SEATS = graphql(`
  mutation BlockSeats($eventId: ID!, $itemsIds: [ID!]!, $blockReason: String!) {
    blockSeats(input: { eventId: $eventId, itemIds: $itemsIds, blockReason: $blockReason }) {
      seats {
        id
        blockReason
        seatId
        status
      }
    }
  }
`);

export const UNBLOCK_SEATS = graphql(`
  mutation UnblockSeats($eventId: ID!, $itemsIds: [ID!]!) {
    unblockSeats(input: { eventId: $eventId, itemIds: $itemsIds }) {
      seats {
        id
        blockReason
        seatId
        status
      }
    }
  }
`);
